import { Chart } from 'react-chartjs-2';
import validate from 'validate.js';
import { observer } from 'mobx-react';
import { ThemeProvider } from '@material-ui/core/styles';
import { chartjs } from './helpers';
import 'react-perfect-scrollbar/dist/css/styles.css';
import validators from './common/validators';
import Routes from './Routes';
import theme from './theme';
import CoursesProvider from './components/CoursesProvider.jsx';
import AuthProvider from './components/AuthProvider.jsx';
import { MathJaxContext } from 'better-react-mathjax';
import { useEffect } from 'react';
import globalMathTableObserver from './utils/mathTableObserver';

//import './assets/scss/index.scss';
import './assets/scss/index.css';
import '../src/content/assets/css/style.css';
import '../src/content/home/css/style.css';
import '../src/content/assets/css/custom.css';
//const browserHistory = createBrowserHistory();

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

export const MATHJAX_CONFIG = {
  loader: { load: ['input/asciimath', 'output/chtml'] }
};

function App() {
  useEffect(() => {
    globalMathTableObserver.start();
    return () => globalMathTableObserver.stop();
  }, []);

  return (
    <MathJaxContext config={MATHJAX_CONFIG}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <CoursesProvider>
            <Routes />
          </CoursesProvider>
        </AuthProvider>
      </ThemeProvider>
    </MathJaxContext>
  );
}

export default observer(App);
